import type { IntlShape } from 'react-intl';

/**
 * Text produced where no `IntlShape` is reachable: the reducer, and anything it stores into state.
 * State holds a message id and its values, never prose, so it stays locale-free.
 *
 * `raw` carries server text. It is never translated, only framed by a translated sentence.
 */
export type ImportMessage =
    | {
          readonly id: string;
          readonly values?: Readonly<Record<string, string | number>>;
      }
    | { readonly raw: string };

export function formatImportMessage(
    intl: IntlShape,
    message: ImportMessage
): string {
    return 'raw' in message
        ? message.raw
        : intl.formatMessage({ id: message.id }, message.values);
}

/** The server's own words when it gave any, else a translated fallback. */
export function errorMessage(
    error: unknown,
    fallbackId: string
): ImportMessage {
    return error instanceof Error && error.message
        ? { raw: error.message }
        : { id: fallbackId };
}
